module.exports = "/images/media-call.svg?198365607665da35a01f2d0ad31781f0";